import Vue from 'vue';
import Vuex from 'vuex';
import VueCookies from 'vue-cookies';
import socketModule from './socket';
import eventsModule from './events';
import albumsModule from './albums';
import userModule from '@shared/js/store/modules/user';
import deviceModule from '@shared/js/store/modules/device';
import followingModule from '@shared/js/store/modules/following';
import notificationsModule from './notifications';

Vue.use(Vuex);
Vue.use(VueCookies);

const store = new Vuex.Store({
	modules: {
		socket:        socketModule,
		notifications: notificationsModule,
		albums:        albumsModule,
		events:        {
			...eventsModule,
			modules: {},
		},
		user:      userModule,
		device:    deviceModule,
		following: followingModule,
	},
});

store.dispatch('device/init');

export default store;
